import { useQuery } from "@tanstack/react-query";
import { findAllAssurances } from "../../lib/queries/assurances-queries";
import { ksHistoriqueAssurancesQK } from "../../lib/query-keys";
import Title from "../ui/Title";
import { ShieldCheck } from "lucide-react";
import Box from "../ui/Box";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { Skeleton } from "../ui/skeleton";
import { Alert } from "../ui/alert";
import AssuranceItem from "./AssuranceItem";

const BlocHistoriqueAssurances = () => {
  const [parent] = useAutoAnimate();
  const { data: assurances, isError } = useQuery({
    queryKey: [ksHistoriqueAssurancesQK],
    queryFn: findAllAssurances,
  });

  return (
    <>
      <Title order={3} className="flex gap-4 mb-4">
        <ShieldCheck /> Historique des assurances
      </Title>
      <Box>
        <div ref={parent} className="flex flex-col gap-5">
          {/* Loading */}
          {!assurances && (
            <>
              <Skeleton className="w-full h-16" />
              <Skeleton className="w-full h-16" />
              <Skeleton className="w-full h-16" />
              <Skeleton className="w-full h-16" />
            </>
          )}

          {/* Error */}
          {isError && (
            <Alert variant={"destructive"} className="text-sm">
              Une erreur s'est produite au chargement de l'historique
            </Alert>
          )}

          {/* Historique vide */}
          {!!assurances && assurances.length === 0 && (
            <div>L'historique des assurances est vide.</div>
          )}

          {/* Data */}
          {!!assurances &&
            assurances.map((assurance) => (
              <AssuranceItem key={assurance.id} assurance={assurance} />
            ))}
        </div>
      </Box>
    </>
  );
};

export default BlocHistoriqueAssurances;
